import { HarpValidators } from '@shared/utils/validators';
import { InputConfig } from '@shared/models/input-config.model';
import { REGEX } from '@shared/constants';

const { EMAIL_REGEX, FIRST_NAME_REGEX, LAST_NAME_REGEX } = REGEX;

export const EMAIL_INPUT_CONFIG: InputConfig = {
  required: true,
  type: 'text',
  label: 'Email Address',
  name: 'email',
};

export const EMAIL_VALIDATORS = [
  HarpValidators.required('Email is required'),
  HarpValidators.pattern(EMAIL_REGEX, 'Email is invalid'),
];

export const FIRST_NAME_INPUT_CONFIG: InputConfig = {
  required: true,
  type: 'text',
  label: 'First Name',
  name: 'firstName',
};

export const FIRST_NAME_VALIDATORS = [
  HarpValidators.required('First Name is required'),
  HarpValidators.pattern(FIRST_NAME_REGEX, 'First Name is invalid'),
];

export const LAST_NAME_INPUT_CONFIG: InputConfig = {
  required: true,
  type: 'text',
  label: 'Last Name',
  name: 'lastName',
};

export const LAST_NAME_VALIDATORS = [
  HarpValidators.required('Last Name is required'),
  HarpValidators.pattern(LAST_NAME_REGEX, 'Last Name is invalid'),
];

export const DOB_INPUT_CONFIG: InputConfig = {
  required: true,
  type: 'date',
  label: 'Date of Birth',
  name: 'dateOfBirth',
};

export const DOB_VALIDATORS = [
  HarpValidators.required('Date of birth is required'),
];
